import { useQuery } from '@hooks/reactQuery';

import { getAssetResultingAccessTypes } from '@api/assetAccess';

import { extractQueryParams } from '@utils/common';
import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { ASSET_ACCESS_RESULTING_TYPES } from '@constants/queryKeys';

interface IUseQueryResultingAssetAccessTypesReturned {
	assetAccessResultingTypes: TSelectOption<string>[];
	isLoadingAssetAccessResultingTypes: boolean;
}

export const useQueryResultingAssetAccessTypes = (): IUseQueryResultingAssetAccessTypesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ASSET_ACCESS_RESULTING_TYPES],
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		queryFn: extractQueryParams(getAssetResultingAccessTypes),
		select: (data) => nameTitleToOptionFormatted(data || []),
		refetchOnWindowFocus: false,
	});

	return {
		assetAccessResultingTypes: data || [],
		isLoadingAssetAccessResultingTypes: isInitialLoading,
	};
};
